import { useCallback, useState } from 'react';
import { Value } from 'react-date-picker/dist/cjs/shared/types';

export const useDatePicker = ({ initDate, selectRange }: { initDate: Value; selectRange: boolean }) => {
  const [value, setValue] = useState<Value>(initDate);
  const onChange = useCallback((date: Value) => {
    setValue(date);
  }, []);

  return { value, onChange, selectRange };
};
